import {ProvincesModel} from "./provinces.model";
import {ProvincesType} from "./provinces.type";
import {IDataFilter} from "../../services/DataTable";
import {Http, URLSearchParams, RequestOptions} from "@angular/http";
import {ListResponseModel, ResponseModel} from "../response/response.model";
import {Observable} from "rxjs/Observable";
import {Injectable} from "@angular/core";

@Injectable()
export class ProvincesService{

    public static PROVINCES_COAS_EAST = 1;
    public static PROVINCES_COAS_WEST = 2;

    private API_ROOT:string = '/provinces';
    constructor(private http: Http) {}

    getList(filter?: IDataFilter): Observable<ListResponseModel<ProvincesModel>> {
        let params: URLSearchParams = new URLSearchParams();
        if (filter) {
            for(let key in filter) {
                params.set(key, filter[key]);
            }
        }

        return this.http
            .get(this.API_ROOT, new RequestOptions({
                search: params
            }))
            .map((res) => {
                let response: ListResponseModel<ProvincesModel> = res.json();

                return response;
            });
    }
}




// WEBPACK FOOTER //
// ./src/app/models/provinces/provinces.service.ts